import { Pipe, PipeTransform } from '@angular/core';


/**
 * Class for filter list by key
 */
@Pipe({
    name: 'rmsSortBy',
    pure: false,
    standalone: false
})
export class RmsSortByPipe implements PipeTransform {

  transform<T>(array: Array<T>, field: string, order?: string): Array<T> {
    if ( array && field ) {
      if ( field.indexOf('.') === -1 ) {
        if ( order && order !== 'DESC' ) {
          array.sort((a: any, b: any) => {
            if (a[field] < b[field]) {
              return -1;
            } else if (a[field] > b[field] || a[field] === null) {
              return 1;
            } else {
              return 0;
            }
          });
        } else {
          array.sort((a: any, b: any) => {
            if (a[field] < b[field] || a[field] === null) {
              return 1;
            } else if (a[field] > b[field]) {
              return -1;
            } else {
              return 0;
            }
          });
        }
      }
    }
    return array;
  }

}
